import { render } from "./ShowVerified.vue?vue&type=template&id=6537d5ec"
import script from "./ShowVerified.vue?vue&type=script&lang=js"
export * from "./ShowVerified.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__